/* global debounce */

// Initialise and observe animate on scroll
if (document.body.classList.contains('cc-animate-enabled')) {
  if ('IntersectionObserver' in window && 'MutationObserver' in window) {
    const initAnimateOnScroll = () => {
      const animatableElems = document.querySelectorAll('[data-cc-animate]:not(.cc-animate-init)');
      if (animatableElems.length > 0) {
        const intersectionObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            // In view and hasn't been animated yet
            if (entry.isIntersecting && !entry.target.classList.contains('cc-animate-in')) {
              entry.target.classList.add('cc-animate-in');
              observer.unobserve(entry.target);
            }
          });
        }, {
          // Start the reveal before the element reaches the viewport, so content
          // is already fading in by the time the user scrolls to it instead of
          // popping in afterwards (the cause of the perceived delay on the
          // home page's near-fold sections). Applies uniformly; the fade itself
          // is unchanged.
          rootMargin: '0px 0px 200px 0px'
        });

        // The per-item cascade delay is `forloop.index * 0.07s`, which on long
        // grids (e.g. 12 collection tiles) reaches ~0.84s and makes content
        // trickle in well after it is visible. Cap it so the whole stagger
        // finishes quickly while keeping the staggered feel for the first items.
        const MAX_ANIMATE_DELAY = 0.4;

        // Initialise and observe each animatable element
        animatableElems.forEach((elem) => {
          // Set the animation delay (clamped)
          if (elem.dataset.ccAnimateDelay) {
            const delay = parseFloat(elem.dataset.ccAnimateDelay);
            elem.style.animationDelay = Number.isNaN(delay)
              ? elem.dataset.ccAnimateDelay
              : `${Math.min(delay, MAX_ANIMATE_DELAY)}s`;
          }

          // Set the animation duration
          if (elem.dataset.ccAnimateDuration) {
            elem.style.animationDuration = elem.dataset.ccAnimateDuration;
          }

          // Init the animation
          if (elem.dataset.ccAnimate) {
            elem.classList.add(elem.dataset.ccAnimate);
          }

          elem.classList.add('cc-animate-init');

          // Watch for elem
          intersectionObserver.observe(elem);
        });
      }
    };

    const aosMinWidth = getComputedStyle(document.documentElement)
      .getPropertyValue('--aos-min-width') || '0';
    const mq = window.matchMedia(`(min-width: ${aosMinWidth}px)`);
    if (mq.matches) {
      initAnimateOnScroll();

      // Check for more animatable elements when the DOM mutates
      document.addEventListener('DOMContentLoaded', () => {
        const observer = new MutationObserver(debounce(initAnimateOnScroll, 250));
        observer.observe(document.body, {
          subtree: true,
          childList: true
        });
      });
    } else {
      document.body.classList.remove('cc-animate-enabled');

      try {
        mq.addEventListener('change', (event) => {
          if (event.matches) {
            document.body.classList.add('cc-animate-enabled');
            setTimeout(initAnimateOnScroll, 100);
          }
        });
      } catch (e) {
        // Legacy browsers (Safari < 14), rely on the animations being shown by the line above the
        // try
      }
    }
  } else {
    // Reveal all the animations
    document.body.classList.remove('cc-animate-enabled');
  }
}
